export function SubmitButton({ loading, disabled, children, className = '', ...rest }) {
  return (
    <button
      type="submit"
      disabled={loading || disabled}
      className={`btn-submit ${className}`.trim()}
      {...rest}
    >
      {loading ? 'Please wait…' : children}
    </button>
  );
}
